<template>
    <transition name="fadeLeft">
        <div v-show="show" class="chatbot-sidebar">
            <div class="chatbot-sidebar--topbar">
                <div class="chatbot-sidebar--topbar__title">{{ $gettext('GekkoBot') }}</div>
                <div class="chatbot-sidebar--topbar__actions">
                    <GekkoButton 
                        @click="resetContext()"
                        icon="fa fa-trash-can"
                        id="clear-conversation"
                    />
                    <b-tooltip target="clear-conversation" triggers="hover">
                        <div class="tooltip-text">
                            {{ $gettext('Clear conversation') }}
                        </div>
                    </b-tooltip>
                    <GekkoButton 
                        @click="$emit('close')"
                        icon="fa-solid fa-xmark"
                    />
                </div>
            </div>
            <AiAssistant :ref="'ai-assistant'" :initialize="show" />
        </div>
    </transition>
</template>

<script>
import AiAssistant from "@/components/AiAssistant"
import GekkoButton from "@/components/GekkoButton";

export default {
    name: "ChatbotSidebar",
    components: {
        AiAssistant,
        GekkoButton
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
        }
    },
    methods: {
        resetContext () {
            this.$refs['ai-assistant'].resetContext()
        }
    }

}
</script>

<style lang="scss">
.chatbot-sidebar {
    display: flex;
    flex-direction: column;
    height: calc(100vh - #{$topbarHeight});
    width: 100%;
    position: fixed;
    right: 0;
    top: $topbarHeight;
    z-index: 1000;
    box-shadow: rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px;
    background: $chatbotPanelBg;

    @media (min-width: '576px') {
        width: 60vw;
    }
    @media (min-width: '768px') {
        width: 600px;
    }
    
    &--topbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: $chatbotPanelBg;
        &__title {
            margin: 0;
            font-size: 20px;
            padding: 0.5rem;
        }
        &__actions {
            display: flex;
            align-items: center;
            .btn {
                border: none;
                background: none;
                color: $colorBrand;
                width: 40px;
                height: 40px;
                &:disabled.btn-primary, &.disabled.btn-primary {
                    color: $colorUnassigned !important;
                    background: none !important;
                }
                &:focus, &:active { 
                    background: none;
                    color: $colorBrand;
                }
                &:hover {
                    color: $colorBrand;
                    background: #dfe2e6;
                }
            }
        }
    }
}
</style>
